import { DcBaseComponent } from '@deleteagency/dc';
import focusLock from 'dom-focus-lock';
import overlay from 'general/js/overlay/default-overlay';
import { eventBus } from 'general/js/events';
import constants from './constants';

export default class SearchMetaComponent extends DcBaseComponent {
    static getNamespace() {
        return 'search-meta';
    }

    static getRequiredRefs() {
        return ['edit', 'cancelEdit'];
    }

    onInit() {
        this._isExpanded = false;
        this.refs.edit.forEach((edit) => this.addListener(edit, 'click', this._onEditClick));
        eventBus.addListener(constants.EVENT_SEARCH_EDIT_CLICK, this._onEditClick);
        this.refs.cancelEdit.forEach((cancelEdit) =>
            this.addListener(cancelEdit, 'click', this._onCancelEditClick));
        overlay.subscribeOnOverlayClick(this._onOverlayClick);
    }

    _onOverlayClick = () => {
        if (this._isExpanded) {
            this._collapse();
            this._isExpanded = false;
        }
    };

    _onEditClick = () => {
        if (!this._isExpanded) {
            this._expand();
            this._isExpanded = true;
            if ('transition' in document.documentElement.style) {
                this.refs.panel.addEventListener('transitionend', this._removeOverflow);
            }
        }
    };

    _onCancelEditClick = () => {
        if (this._isExpanded) {
            this._collapse();
            this._isExpanded = false;
        }
    };

    _expand() {
        focusLock.on(this.element);
        this.element.classList.add('is-expanded');
        overlay.show('search-meta');
    }

    _collapse() {
        this._addOverflow();
        this.element.classList.remove('is-expanded');
        overlay.hide('search-meta');
        focusLock.off(this.element);
    }

    _addOverflow = () => {
        this.refs.slider.style.overflow = 'hidden';
    };

    _removeOverflow = () => {
        this.refs.slider.style.overflow = 'visible';
        this.refs.panel.removeEventListener('transitionend', this._removeOverflow);
    };
}
